<script setup>

import FinishPage from "@/components/shared/FinishPage.vue";
import {onMounted, ref} from "vue";
import {useSignUpStore} from "@/store/signup";
import {useRoute, useRouter} from "vue-router";

const error = ref('')
const signUpStore = useSignUpStore();
const route = useRoute()
const router = useRouter()
onMounted(async () => {
    const enrollmentToken = await signUpStore.doActivation(route.query.code)
    if(signUpStore.error) {
      error.value = signUpStore.error
      return;
    }
    if (!enrollmentToken) {
      error.value = 'Не удалось подготовить установку пароля'
      return;
    }
    await router.replace({name: 'ChangePasswordView', query: {code: enrollmentToken}});
})

</script>

<template>
  <div class="activationView">

    <finish-page v-if="!error">
      <template #mainText>
        <span class="activationView__head">
          Идет активация учетной записи...
        </span>
      </template>
      <template #infoText>
      </template>

    </finish-page>

    <finish-page v-else button-caption="Домой" :exit-route="{name: 'HomePage'}"  style="background-color: darkred;color: white">
      <template #mainText>
          <span class="activationView__head">
              Ошибка активации учётной записи
          </span>
      </template>
      <template #infoText>
        {{error}}

      </template>

    </finish-page>
  </div>
</template>

<style scoped lang="scss">
.activationView {
  &__head {
    font-weight: 500;
    font-size: 36px;
    font-family: var(--cd-bold-font);
  }
  &__info {
  }
}
</style>
